import React, { useEffect, useState } from 'react'
import classes from './MyStudentsProlongations.module.css'
import { Button, Grid, Input, Table, Tbody, Th, Thead, Tr, useToast } from '@chakra-ui/react'
import { useProlongationsStore } from '../../store/prolongationsStore'
import MyStudentsProlongationsTableRecord from '../../components/MyStudentsProlongationsTableRecord/MyStudentsProlongationsTableRecord'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import StudentsService from '../../API/StudentsService'
import { useGlobalStore } from '../../store/globalStore'
import UmSpinner from '../../components/UI/UmSpinner'
import { toastError, toastWarning } from '../../utils/globalHelper'
import { useStudentsStore } from '../../store/studentsStore'

function MyStudentsProlongations() {
    const toast = useToast()
    const user = useGlobalStore(state => state.user)
    const [prolongations, setProlongations] = useProlongationsStore(state => [state.prolongations, state.setProlongations])
    const fetchMailingStatuses = useProlongationsStore(state => state.fetchMailingStatuses)
    const fetchCommunicationTypes = useStudentsStore(state => state.fetchCommunicationTypes)

    const [filters, setFilters] = useState({
        filter_start_date: '',
        filter_end_date: '',
    })
    const [isLoading, setIsLoading] = useState(false)

    const getProlongations = useAccessAPI(StudentsService.getStudentsProlongations)

    useEffect(() => {
        fetchCommunicationTypes()
        fetchMailingStatuses()

        const date = new Date()
        date.setDate(1)
        const endMonthDate = new Date(date.getFullYear(), date.getMonth() + 1)
        setFilters({
            ...filters,
            filter_start_date: date.toISOString().substring(0, 10),
            filter_end_date: endMonthDate.toISOString().substring(0, 10),
        })
    }, [])

    const onMonthChanged = (e) => {
        const monthDate = new Date(e.target.value)
        const endMonthDate = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1)
        setFilters({
            ...filters,
            filter_start_date: monthDate.toISOString().substring(0, 10),
            filter_end_date: endMonthDate.toISOString().substring(0, 10),
        })
    }

    const fetchProlongations = async () => {
        setIsLoading(true)
        const response = await getProlongations(filters)
        if (response?.status === 200) {
            setProlongations(response.data)
            if (response.data?.length < 1)
                toast(toastWarning('Не удалось найти учеников'))
        }
        else {
            toast(toastError('Ошибка при загрузке продлений'))
        }
        setIsLoading(false)
    }

    return (
        <Grid gap='var(--default-gap)'>
            <Grid className={classes.wrapper}>
                <Input
                    type='month'
                    value={filters?.filter_start_date.substring(0, 7)}
                    onChange={onMonthChanged}
                />
                <Button onClick={fetchProlongations}>
                    Обновить
                </Button>
            </Grid>
            {
            isLoading
            ?
                <UmSpinner />
            :
                prolongations && prolongations.length > 0
                &&
                <div className={classes.container}>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th className={classes.fixedCol}>Имя</Th>
                                <Th>ID платформы</Th>
                                <Th>Тип предпочтительной связи</Th>
                                <Th>Предмет</Th>
                                <Th>Пакет</Th>
                                <Th>Поток</Th>
                                <Th>Класс</Th>
                                <Th>Отписка</Th>
                                <Th>Дата 1 отписки</Th>
                                <Th>Статус</Th>
                                <Th>Дата 2 отписки</Th>
                                <Th>Статус</Th>
                                <Th>Дата 3 отписки</Th>
                                <Th>Статус</Th>
                                <Th>Итоговый статус</Th>
                                <Th>Комментарий</Th>
                                <Th>Успеваемость</Th>
                                <Th>Старый/новый ученик</Th>
                                <Th>Автооплата</Th>
                                <Th>Когорта</Th>
                                <Th></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {prolongations.map(obj => (
                                <MyStudentsProlongationsTableRecord
                                    prolongation={obj}
                                    key={`prolong${obj.prolongation_id}`}
                                />
                            ))}
                        </Tbody>
                    </Table>
                </div>
            }
        </Grid>
    )
}

export default MyStudentsProlongations
